// extracted by mini-css-extract-plugin
export default {"logoLink":"index_logoLink_z1fOH","subLogo":"index_subLogo_JImSx"};